import request from "../helpers/request"

const payment = {}

payment.getLink = async (data) => {
    return request.get('/payment/get', data, false, true)
}

export default payment